module.exports = __webpack_public_path__ + "static/img/s01@2x.a983c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s01@2x.png
// module id = BWP5
// module chunks = 2